<template>
  <v-card class="lead-form-desktop">
    <!-- 닫기 버튼 -->
    <v-btn icon class="close-button" @click="$emit('close')">
      <v-icon color="#3A3A3A">mdi-close</v-icon>
    </v-btn>

    <div class="desktop-content">
      <!-- 좌측: 전문가 상담 섹션 -->
      <div class="expert-section">
        <!-- 헤더 -->
        <div class="expert-header">
          <h2 class="expert-main-title">매출 올리는 방법,<br />무료 상담에서 확인하세요!</h2>
          <p class="expert-subtitle">상담을 신청한 업체 10곳 중 9곳은<br />키워드 설정이 잘못되어 있어요.</p>
          <p class="expert-subtitle2">
            키워드만 제대로 설정해도<br />
            평균 매출이 23% 늘어납니다.
          </p>
        </div>

        <!-- 리스트 -->
        <div class="expert-list-wrapper">
          <div class="expert-list-title">전문가와 함께 하는 무료 상담</div>
          <div class="expert-list">
            <!-- 매장일 때만: 우리 매장 플레이스 진단 -->
            <div v-if="formData.type === 'STORE'" class="expert-item">
              <div class="expert-icon-wrapper">
                <img
                  src="@/assets/img/lead-modal/expert_place_analysis.png"
                  alt="우리 매장 플레이스 진단"
                  class="expert-icon" />
              </div>
              <span class="expert-text">우리 매장 플레이스 진단</span>
            </div>

            <div class="expert-item">
              <div class="expert-icon-wrapper">
                <img
                  src="@/assets/img/lead-modal/expert_blog_strategy.png"
                  alt="맞춤 블로그 마케팅 전략"
                  class="expert-icon" />
              </div>
              <span class="expert-text">맞춤 블로그 마케팅 전략</span>
            </div>

            <div class="expert-item">
              <div class="expert-icon-wrapper">
                <img
                  src="@/assets/img/lead-modal/expert_keyword_point.png"
                  alt="매출 개선 키워드 포인트"
                  class="expert-icon" />
              </div>
              <span class="expert-text">매출 개선 키워드 포인트</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 우측: 폼 섹션 -->
      <div class="form-section">
        <!-- 탭 버튼 -->
        <LeadFormTabs :type.sync="localType" class="mb-4" />

        <!-- 체험단 헤더 -->
        <LeadExperienceHeader :type="formData.type" class="mb-4" />

        <!-- 폼 컨테이너 -->
        <div class="form-container">
          <div class="form-wrapper">
            <!-- 폼 컨텐츠 -->
            <LeadFormContent
              :formData="formData"
              :items="items"
              :showAvailableTime="true"
              @update:formData="handleUpdateFormData"
              @validation="handleValidation" />

            <!-- 제출 버튼 -->
            <v-btn :disabled="!isFormValid" class="submit-button" @click="$emit('submit')" block depressed>
              무료 상담하기
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import LeadFormTabs from './LeadFormTabs.vue';
import LeadExperienceHeader from '../header/LeadExperienceHeader.vue';
import LeadFormContent from './LeadFormContent.vue';

export default {
  name: 'LeadFormDesktop',

  components: {
    LeadFormTabs,
    LeadExperienceHeader,
    LeadFormContent,
  },

  props: {
    formData: {
      type: Object,
      required: true,
    },
    isFormValid: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      items: [
        { text: '시간 무관', value: '시간 무관' },
        { text: '10:00 ~ 11:30', value: '10:00-11:30' },
        { text: '14:00 ~ 15:30', value: '14:00-15:30' },
        { text: '15:30 ~ 17:30', value: '15:30-17:30' },
      ],
    };
  },

  computed: {
    localType: {
      get() {
        return this.formData.type;
      },
      set(value) {
        this.$emit('update:formData', { ...this.formData, type: value });
      },
    },
  },

  methods: {
    handleUpdateFormData(data) {
      this.$emit('update:formData', data);
    },

    handleValidation(isValid) {
      this.$emit('handleFormValid', isValid);
    },
  },
};
</script>

<style scoped lang="scss">
.lead-form-desktop {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  // padding: 120px 300px 120px 270px !important;
  position: relative;
  width: 100% !important;
  // height: 100% !important;
  min-height: 100vh !important;
  background: #ffffff !important;
  border-radius: 0 !important;
  overflow-y: auto !important;
  margin: 0 !important;
  box-sizing: border-box !important;
}

::v-deep .lead-form-desktop.v-card {
  width: 100% !important;
  height: 100% !important;
  min-height: 100vh !important;
  border-radius: 0 !important;
  margin: 0 !important;
}

/* 닫기 버튼 */
.close-button {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 10;
}

/* 메인 컨텐츠: 좌우 2단 */
.desktop-content {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0;
  gap: 70px;
  width: 100%;
  max-width: 900px;
}

/* ===== 좌측: 전문가 섹션 ===== */
.expert-section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0;
  gap: 48px;
  flex: 1;
  order: 0;
  min-width: 0;
}

/* 전문가 헤더 */
.expert-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0;
  gap: 24px;
  width: 100%;
  align-self: stretch;

  .expert-main-title {
    font-family: 'Spoqa Han Sans Neo';
    font-style: normal;
    font-weight: 700;
    font-size: 32px;
    line-height: 44px;
    color: #212121;
    width: 100%;
    align-self: stretch;
    margin: 0;
  }

  .expert-subtitle,
  .expert-subtitle2 {
    font-family: 'Spoqa Han Sans Neo';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #808080;
    width: 100%;
    margin: 0;
  }
}

/* 전문가 리스트 래퍼 */
.expert-list-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0;
  gap: 8px;
  width: 100%;
  align-self: stretch;
}

.expert-list-title {
  font-family: 'Spoqa Han Sans Neo';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: #202020;
  width: 168px;
}

/* 전문가 리스트 */
.expert-list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
  gap: 8px;
  width: 100%;
  background: #fbfbfb;
  border-radius: 8px;
  align-self: stretch;
}

.expert-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0;
  gap: 8px;
  width: 100%;
  height: 48px;
  align-self: stretch;
}

.expert-icon-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px;
  gap: 10px;
  width: 48px;
  height: 48px;
  background: #e6f3ff;
  border-radius: 12px;
  flex: none;
}

.expert-icon {
  width: 32px !important;
  height: 32px !important;
  flex: none;
  object-fit: contain;
}

.expert-text {
  font-family: 'Spoqa Han Sans Neo';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #202020;
  flex: 1;
}

/* ===== 우측: 폼 섹션 ===== */
.form-section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0;
  gap: 16px;
  flex: 1;
  order: 2;
  min-width: 0;
}

/* 데스크탑 전용: 탭 섹션 고정 너비 */
::v-deep .tab-section {
  width: 216px;
  height: 42px;
  flex: none;
  order: 0;

  .tab-btn {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 8px 16px;
    width: 100px;
    flex: none;
  }
}

/* 폼 컨테이너 */
.form-container {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px;
  gap: 40px;
  width: 100%;
  border: 1px solid #f5f5f5;
  border-radius: 8px;
  flex: none;
  order: 1;
  align-self: stretch;
  overflow-x: hidden;
}

.form-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0;
  gap: 12px;
  width: 100%;
  align-self: stretch;
}

/* 데스크탑 전용: 체험단 헤더 배경색 오버라이드 */
::v-deep .experience-header {
  background: #fbfbfb;
  padding: 8px 24px;
  height: 76px;
}

/* 제출 버튼 */
.submit-button {
  width: 100%;
  height: 42px !important;
  min-height: 42px !important;
  background: #ea2a3a !important;
  border-radius: 8px !important;
  font-family: 'Spoqa Han Sans Neo';
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  color: #f5f5f5 !important;
  text-transform: none;
  letter-spacing: 0;
  box-shadow: none !important;
  margin-top: 16px;

  &:disabled,
  &.v-btn--disabled {
    background: #dbdbdb !important;
    color: #f5f5f5 !important;
  }
}
</style>
